import {
  doc,
  setDoc,
  serverTimestamp,
  query,
  orderBy,
  collection,
  limit,
  getDocs
} from "firebase/firestore";

import { db } from "../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "../components_root/rendom_code";

export const Plugins_install_page = async (data) => {

  const {
    plugins_name,
    plugins_description,
    pageuid,
    companyuid
  } = data || {};

  // ================= VALIDATION =================
  if (!plugins_name?.trim()) {
    return { success: false, error: "Missing plugin name" };
  }

  if (!plugins_description?.trim()) {
    return { success: false, error: "Missing plugin description" };
  }

  if (!pageuid || !companyuid) {
    return { success: false, error: "Missing page or company ID" };
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");

  if (!sessiontoken || !guid) {
    return { success: false, error: "Session expired. Please relogin." };
  }

  try {
    const pagesRef = collection(
      db,
      "companies",
      companyuid,
      "pages",
      pageuid,
      "plugins"
    );

    // ================= GENERATE NEW ID =================
    const pluginstalluid = Randomcode(8);
    const docRef = doc(pagesRef, pluginstalluid);

    // ================= INDEX NUMBER =================
    let indexnumber = 1;

    const indexQuery = query(
      pagesRef,
      orderBy("indexnumber", "desc"),
      limit(1)
    );

    const indexSnapshot = await getDocs(indexQuery);

    if (!indexSnapshot.empty) {
      const lastIndex = indexSnapshot.docs[0].data().indexnumber || 0;
      indexnumber = lastIndex + 1;
    }

    // ================= SAVE =================
    await setDoc(docRef, {
      ...data,
      pluginstalluid,
      pageuid,
      guid,
      companyuid,
      sessiontoken,
      indexnumber,
      date_time: serverTimestamp(),
      update_date_time: serverTimestamp()
    });

    return { success: true };

  } catch (err) {
    console.error("❌ Error saving plugin:", err);

    return {
      success: false,
      error: err.message || "Unknown error"
    };
  }
};